import ReactDOM from 'react-dom/client';
import './index.scss';
import { store } from './store/index';
import { Provider } from 'react-redux';
import { Stack } from '@mui/material';
import LoginMSALProvider from './login/LoginMSALProvider';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { BluCloudThemeProvider } from '@bludata/components';
import SomethingWrong from './UI/SomethingWrong';
import isBrowserCompatible from './utility_objects/checkBrowserCompatibility';
import BrowserNotCompatible from './UI/BrowserNotCompatible';
import localforage from 'localforage';

const HTMLNode = document.getElementById('root') as HTMLElement;
HTMLNode.style.display = 'flex';

const startLogo = document.getElementById('startLogo');
if (startLogo) startLogo.parentElement?.removeChild(startLogo);

// root deve essere visibile anche in renderFallbackApp
const root = ReactDOM.createRoot(HTMLNode);

// Config localforage
localforage.config({
  name: 'focuscloud_terminal',
  storeName: 'focuscloud_terminal_store',
  description: 'Storage for login prefill and user preferences',
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE, // fallback sicuro
  ],
});

// bootstrap dell’app: qui puoi usare await
async function bootstrap() {
  try {
    const browserCompatible = isBrowserCompatible();

    if (!browserCompatible) {
      root.render(
        <Stack flex={1} sx={{ position: 'relative' }}>
          <Provider store={store}>
            <BluCloudThemeProvider themeMode={'light'}>
              <BrowserNotCompatible />
            </BluCloudThemeProvider>
          </Provider>
        </Stack>,
      );
    } else {
      root.render(
        <Stack flex={1} sx={{ position: 'relative' }}>
          <Provider store={store}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={'it'}
            >
              <LoginMSALProvider />
            </LocalizationProvider>
          </Provider>
        </Stack>,
      );
    }
  } catch (err) {
    console.error('Errore durante bootstrap/migrazione:', err);
    // volendo potresti qui già mostrare SomethingWrong
    root.render(
      <Stack flex={1} sx={{ position: 'relative' }}>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <BluCloudThemeProvider themeMode={'light'}>
              <SomethingWrong />
            </BluCloudThemeProvider>
          </LocalizationProvider>
        </Provider>
      </Stack>,
    );
  }
}

bootstrap();

export function renderFallbackApp() {
  root?.unmount();
  HTMLNode.parentElement?.removeChild(HTMLNode);
  const newDivRoot = document.createElement('div');
  newDivRoot.id = 'root';
  document.body.appendChild(newDivRoot);
  const newHTMLNode = document.getElementById('root') as HTMLElement;
  const fallbackRoot = ReactDOM.createRoot(newHTMLNode);

  fallbackRoot.render(
    <Stack flex={1} sx={{ position: 'relative' }}>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
          <BluCloudThemeProvider themeMode={'light'}>
            <SomethingWrong />
          </BluCloudThemeProvider>
        </LocalizationProvider>
      </Provider>
    </Stack>,
  );
}
